module.exports = __webpack_public_path__ + "static/img/img-7.4dbb8c9d.jpg";